/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import '../behaviors/keyboard-accessibility.js';
import '../../../behaviors/app-menu-access-behaviour.js';

const template = html`
		<style include="app-styles">
             .border-round-brand-color{
                border:1px solid var(--brand-color);
                border-radius :24px;
            }
            .padding-4px{
                padding: 4px;
            }
			.margin-b-5px {
				margin-bottom: 5px;
			}
			.dis-inline-block {
              display: inline-block;
            }
            .dis-inline-block oe-i18n-msg {
              vertical-align: middle;
            }
             @media only screen and (min-device-width : 320px) and (max-device-width : 767px){

                .text-brand-color{

                    color:var(--primary-light-color) !important;

                }

                .secondary-dark-text-l,.secondary-dark-text-xxl,.secondary-dark-text-s{

                    color:var(--primary-light-color);

                }

                .border-round-brand-color{

                    border:1px solid var(--primary-light-color);

                }

            }
		</style>

        <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
        
        <div class$="{{_addClassBasedOnDevice(desktop)}}">
            <div tabindex="0" on-tap="_navigateToSaving" on-keydown="_navigateToSavingDDA" class="outlineOffset">
                <div hidden$={{!desktop}} class="text-transform-uppercase disabled-dark-color font-size-s">
                    <oe-i18n-msg msgid="h_Accounts"></oe-i18n-msg>
                     <div class="padding-4px"></div>
                </div>
                <div hidden$={{!savingsAvailable}}>
                    <template is="dom-if" if="{{savingsLoader}}">
                        <paper-spinner id="dashboard_user_savings_spinner" active></paper-spinner>
                    </template>
                    <template is="dom-if" if="{{!savingsLoader}}">
                        <template is="dom-if" if="{{!isMenuId}}">
                            <div>
                              
                                <template is="dom-repeat" items="{{primaryBalance}}">
                                    <div id="dashboard_user_saving_amount_{{index}}">
                                        <div class="outlineOffset secondary-dark-text-xxl font-weight-bold cursor-pointer" on-tap="_navigateToSaving" hidden$={{desktop}} tabindex="0">
                                        <currency-formator format-value={{item.amount}} tooltipnotrequired={{!item.showTooltip}}></currency-formator> 
                                        </div>
                                        <div class="outlineOffset secondary-dark-text-l font-weight-bold cursor-pointer" on-tap="_navigateToSaving" hidden$={{!desktop}} tabindex="0">
                        <currency-formator format-value={{item.amount}} tooltipnotrequired={{!item.showTooltip}} formatting-amount=true></currency-formator> 
                                        </div>
                                    </div>
                                </template>
                                  <div class="secondary-dark-text-s" hidden$={{desktop}}>
                                    <oe-i18n-msg msgid="m_DashboardMessage4"></oe-i18n-msg>
                                </div>
                                <div class="secondary-dark-text-xs" hidden$={{!desktop}}>
                                    <oe-i18n-msg msgid="m_DashboardMessage4"></oe-i18n-msg>
                                </div>
                            </div>
                        </template>
                        <template is="dom-if" if="{{isMenuId}}">
                            <oe-i18n-msg class="font-size-m" msgid="l_PermissionErrorMessage"></oe-i18n-msg>
                        </template>
                    </template>
                </div>
                <div hidden$={{savingsAvailable}}>
                    <div hidden$={{desktop}}>
                        <div class="secondary-dark-text-s">
                        </div>
                        <div class="mdl-grid mdl-grid--no-spacing font-weight-bold secondary-dark-text-l content-align-center">
                            <div class="mdl-cell mdl-cell--9-col mdl-cell--3-col-phone mdl-cell--6-col-tablet">{{savingsSuggestions.text}}</div>
                        </div>
                        <div class="mdl-grid">
                            <div class="mdl-cell mdl-cell--12-col content-align-center">
                            <template is="dom-if" if={{!prospectIndicatorFlag}}>
                                <div class="border-round-brand-color mdl-grid padding-t-zero padding-b-zero text-brand-color">
                                <paper-button  on-tap="createAccountDIB"><oe-i18n-msg msgid="b_apply"></oe-i18n-msg></paper-button>
                                </div>
                            </template>                                 
                            </div>
                        </div>
                    </div>
                    <div hidden$={{!desktop}}>
                        <div class="secondary-dark-text-s">
                        </div>
                        <div class="font-weight-bold secondary-dark-text-l">
                            {{savingsSuggestions.text}}
                        </div>
                        <div>
                            <template is="dom-if" if={{!prospectIndicatorFlag}}>
                            <div class="padding-4px padding-l-zero">
                                <paper-button  class="margin-zero border-round-brand-color padding-4px text-brand-color font-size-s" on-tap="createAccountDIB"><oe-i18n-msg msgid="b_apply"></oe-i18n-msg></paper-button>
                            </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
		<div class$="{{_addClassBasedOnDevice(desktop)}}">
		<template is="dom-if" if={{otherCurrenciesFlag}}>
          <span id="other_currencies" class="secondary-dark-text-xs dis-inline-block cursor-pointer" role="none">
            <iron-icon icon="info-outline" class=""></iron-icon>&nbsp;<oe-i18n-msg msgid="l_otherCurrency"></oe-i18n-msg></span>
            <paper-tooltip for="other_currencies" class="" position="{{positionTooltip}}" offset="0" aria-hidden="true" >
                  <div class="tooltip-container">
                    <template is="dom-repeat" items="{{otherCurrencies}}">
                        <div class="margin-b-5px">{{item.amount}}</div>
                    </template>
                  </div>
              </paper-tooltip>
		  </template>
          </div>`;


Polymer({
    is: 'dashboard-user-saving',
    behaviors: [corpBehaviours.appMenuBehaviour, accessibilityBehaviours.commonFunctions],
    _template: template,
    properties: {
        savings: {
            type: Array,
            notify: true,
            observer: '_savingsListChanged'
        },
        savingsLoader: {
            type: Boolean,
            value: true,
            notify: true
        },
        savingsAccountSchemes: {
            type: Array,
            value: ['CAA', 'SBA']
        },
        savingsAmountList: {
            type: Array,
            notify: true,
            observer: "_checkPrimaryAccountCurrency"
        },
        savingsAvailable: {
            type: Boolean,
            value: true,
            notify: true
        },
        savingsSuggestions: {
            type: Object,
            notify: true
        },
        prospectIndicatorFlag: {
            type: Object,
            computed: 'computeProspectIndicator()'
        },
        menuId: {
            type: String,
            notify: true,
            value: "ORACC"
        },
        isMenuId: {
            type: Boolean,
            notify: true
        },
		primaryAccountObj: {
		  type: Object,
		  notify: true,
		  observer: "_checkPrimaryAccountCurrency"
		},
		otherCurrencies: {
		  type: Array,
		  value: [],
		  notify: true
		},
		otherCurrenciesFlag: {
		  type: Boolean,
		  value: false,
		  notify: true
		},
		primaryBalance: {
		  type: Array,
		  value: [],
		  notify: true
		}
    },
    attached: function () {
        this.set('isMenuId', this.validateElement(this.menuId))
    },
    computeProspectIndicator: function () {
        return clientStorage.get(storageType.session, "prospectIndicator") == "Y";
    },
    _addClassBasedOnDevice: function (desktop) {
        if (desktop)
            return "";
        return "text-align-center";
    },
    _goToSuggestion: function () {
        var url = this.savingsSuggestions.url;
        window.oe_navigate_to(url, "");
    },
    _navigateToSaving: function () {
        if(this.isMenuId)
            return;
        var detailsURL = "/oprAccounts";
        var detailsNavigationData = { "oprAccountList": this.savings };
        if (!window.google || !window.google.charts) {
            var script = document.createElement('script');
            script.type = "application/javascript";
            script.async = false;
            script.src = 'https://www.gstatic.com/charts/loader.js';
            script.onload = function () {
                window.oe_navigate_to(detailsURL, detailsNavigationData);
            }
            script.onerror = function () {
                window.oe_navigate_to(detailsURL, detailsNavigationData);
            }
            document.head.appendChild(script);
        }
        else {
            window.oe_navigate_to(detailsURL, detailsNavigationData);
        }
    },
    _savingsListChanged: function () {
        var currencyValueList = [];
        var currencyValueMap = {};
        var savingsAmountList = [];
        var pageTitle = document.getElementById('page-title-label');
        if (this.savings) {
            if (this.savings.length > 0) {
                for (var i = 0; i < this.savings.length; i++) {
                    if (this.savingsAccountSchemes.indexOf(this.savings[i].accountType.cmCode) > -1) {
                        var account = this.savings[i];
                        for (var j = 0; j < account.balances.length; j++) {
                            if (account.balances[j].type == "availableBalance") {
                                if (currencyValueMap[account.balances[j].amountDetails.currency] != undefined) {
                                    var temp = currencyValueMap[account.balances[j].amountDetails.currency];
                                    currencyValueList[temp] = Number(currencyValueList[temp]) + Number(account.balances[j].amountDetails.amount);
                                }
                                else {
                                    currencyValueList.push(Number(account.balances[j].amountDetails.amount));
                                    currencyValueMap[account.balances[j].amountDetails.currency] = currencyValueList.length - 1;
                                }
                            }
                        }
                    }
                }

                for (var key in currencyValueMap) {
                    var index = currencyValueMap[key];
                    var val = currency.symbolize(key + ' ' + currencyValueList[index])
          var amountValue = val.slice(2, val.length);
          amountValue = amountValue[amountValue.length - 3] == "." ? amountValue.slice(0, amountValue.length - 3) : amountValue;
          var showTooltip = amountValue.length >= 4 ? true : false;
          savingsAmountList.push({ "amount": val, "showTooltip": showTooltip });
                }
                this.savingsAmountList = savingsAmountList
                if (this.$$("#dashboard_user_savings_spinner") != null)
                    this.$$("#dashboard_user_savings_spinner").active = false;
                this.savingsLoader = false;
            }
            else if (pageTitle.appData.savingsSuggestionsCallDone === undefined){
                var self = this;
                this.savingsAvailable = false;
                pageTitle.appData.savingsSuggestionsCallDone = true;
                if (this.prospectIndicatorFlag) {
                    if (this.$$("#dashboard_user_savings_spinner") != null)
                        this.$$("#dashboard_user_savings_spinner").active = false;
                    this.savingsLoader = false;
                    this.set('savingsSuggestions', {});
                    pageTitle.appData.savingsSuggestions = this.savingsSuggestions;
                    return;
                }
                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = "/api/accountSuggestions/savings";
                ajaxCall.method = 'get';
                ajaxCall.addEventListener('response', function (event) {
                    if (event.detail.response != null) {
                        var suggestions = event.detail.response.accountSuggestion;
                        self.set('savingsSuggestions', suggestions);
                        pageTitle.appData.savingsSuggestions = self.savingsSuggestions;
                    }
                    if (self.$$("#dashboard_user_savings_spinner") != null)
                        self.$$("#dashboard_user_savings_spinner").active = false;
                    self.savingsLoader = false;
                });
                ajaxCall.addEventListener("error", function (e) {
                    self.serviceError(e);
                });
                oeAjaxEventListner(ajaxCall);
                ajaxCall.generateRequest();
            }
            else {
                if (this.$$("#dashboard_user_savings_spinner") != null)
                     this.$$("#dashboard_user_savings_spinner").active = false;
                this.savingsLoader = false;
                this.savingsAvailable = false;
                if (pageTitle.appData.savingsSuggestions)
                    this.set('savingsSuggestions', pageTitle.appData.savingsSuggestions);
            }
        }
    },
    serviceError: function () {
        // this.fire("oe-show-error","Please try after sometime. Currently we are not able to process your request due to technicle issues");
        if (this.$$("#dashboard_user_savings_spinner") != null)
            this.$$("#dashboard_user_savings_spinner").active = false;
        this.savingsLoader = false;
        this.set('savingsSuggestions', {});
        //TODO
        // log clientside issues 
    },
    createAccountDIB: function () {
        var isExistingCustomer = "Y";
        var existingCustomerInfo = {};
	var self = this;
        existingCustomerInfo.isExistingCustomer = isExistingCustomer;
        //existingCustomerInfo.selectedProductCategories = ["Savings", "Current"];
        // Replacing the hardcoded values by fetching it from API call as part of feature 301794
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/retailproduct-categories?filter[where][mainCategory]=5|6";
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function(event) {
            let response = event.detail.response;
            existingCustomerInfo.selectedProductCategories = _.map(response.productCategoryDetails, function(prod) { return prod.productCategoryId.codeDescription });
            window.oe_navigate_to("/directbanking", {
                "existingCustomerInfo": existingCustomerInfo
            });
        });
        ajaxCall.addEventListener("error", function(e) {
            existingCustomerInfo.selectedProductCategories = [];
      var errMsg = JSON.parse(e.detail.request.__data.response.error.message["channelcontext"]);
      self.fire('oe-show-error', errMsg.status.message[0].messageDesc);
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    },
    _navigateToSavingDDA(keyboardEvent) {
        if (keyboardEvent.keyCode === 13 || keyboardEvent.which === 13) {
            this._navigateToSaving(keyboardEvent);
        }
    },
    _checkPrimaryAccountCurrency: function () {
        this.otherCurrencies = [];
        this.primaryBalance = [];
        this.otherCurrenciesFlag = false;
        let primaryCurrency = _.isEmpty(this.primaryAccountObj) ? "" : currency.symbolize(this.primaryAccountObj.accountCurrency.cmCode);

        if (this.savingsAmountList) {
            for (let amount of this.savingsAmountList) {
                if (amount.amount.split(" ")[0] == primaryCurrency) {
                    this.primaryBalance.push(amount);
                } else {
                    this.otherCurrenciesFlag = true;
                    this.otherCurrencies.push(amount);
                }
            }
            if (this.primaryBalance.length == 0) {
                this.primaryBalance.push(this.otherCurrencies[0]);
                this.otherCurrencies.splice(0, 1);
                this.otherCurrenciesFlag = this.otherCurrencies.length ? true : false;
            }
        }
    }
});
